import {debounce, fetchData} from "../../utils/common";
import {changeAmountCount} from "../cart";

export const changeDisabledButtonStatus = (button, isNotDisabled) => (button.disabled = isNotDisabled);

export const changeCount = (parent, setPrice, isFastOrder, initialValue) => {
  if (parent) {
    const modalCountElement = parent.querySelector(`.js-modal-count`);
    const priceElement = parent.querySelector(`.js-cart-item-price`);
    const discountElement = parent.querySelector(`.js-cart-item-old-price`);
    const plusButtonElement = modalCountElement.querySelector(`.js-modal-count-plus`);
    const minusButtonElement = modalCountElement.querySelector(`.js-modal-count-remove`);
    const countInputElement = modalCountElement.querySelector(`.js-modal-count-input`);

    if (initialValue) {
      countInputElement.value = initialValue;
    }

    const fetchCount = () => {
      const URL = getUrl();

      fetchData(URL).then((data) => {
        if (data.countAll) {
          changeAmountCount(data.countAll);
          changeDisabledButtonStatus(minusButtonElement, !Boolean(countInputElement.value > 1));

          if (setPrice) {
            setPrice.setPrices(data);
          }

          if (priceElement) {
            priceElement.textContent = data.priceThisTotal;
          }

          if (discountElement) {
            discountElement.textContent = data.totalThisDiscount;
          }
        }
      });
    };

    const getUrl = () => {
      const productId = modalCountElement.dataset.productId;
      return `${modalCountElement.dataset.changeCartUrl}${productId ? `id=${productId}` : ``}&count=${countInputElement.value}`;
    };

    const changeCountFromServer = debounce(() => fetchCount(), 300);

    const changeCount = (value) => {
      setPrice(value);
      changeDisabledButtonStatus(minusButtonElement, !Boolean(value > 1));
    };

    const onPlusButtonClick = () => {
      countInputElement.value++;

      if (!isFastOrder) {
        changeCountFromServer();
      } else {
        changeCount(countInputElement.value);
      }
    };

    const onMinusButtonClick = () => {
      if (countInputElement.value > 1) {
        countInputElement.value--;

        if (!isFastOrder) {
          changeCountFromServer();
        } else {
          changeCount(countInputElement.value);
        }
      }
    };

    const onCountInputChange = () => {
      if (!isFastOrder) {
        changeCountFromServer();
      } else {
        changeCount(countInputElement.value);
      }
    };

    plusButtonElement.addEventListener(`click`, onPlusButtonClick);
    minusButtonElement.addEventListener(`click`, onMinusButtonClick);
    countInputElement.addEventListener(`change`, onCountInputChange);
  }
};
